module.exports = __webpack_public_path__ + "img/progress_030.a7a10667.png";